import axios from 'axios';
import i18n from '@/locales/index';
const {t}=i18n.global
const baseURL = process.env.VUE_APP_API_URL;
const timeout = 30000;

const instance = axios.create({
  baseURL,
  timeout,
});

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    console.log('请求拦截器 - 请求发送前:', config);
    return config;
  },
  (error) => {
    console.error('请求拦截器 - 请求发送错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  response => response,
  error => {
    if (error.code === "ECONNABORTED" || error.message.includes("timeout")) {
      return Promise.reject({
        message: t('Home.overtime'),
        error,
      });
    }
    if (error.message === "Network Error") {
      return Promise.reject({
        message:t('Home.networkError'),
        error,
      });
    }
    if (error.response) {
      return Promise.reject(error.response.data);
    } else {
      return Promise.reject({
        message: t('Home.noResponse'),
        error,
      });
    }
  }
);

// 封装请求方法
export const request = async (config) => {
  try {
    const response = await instance(config);
    return response;
  } catch (error) {
    throw error;
  }
};

export default instance;